import type mdast from 'mdast';
import { MarkdownParentBuffer } from './markdownParentBuffer';

/** Collects phrasing content AST nodes, and flushes them as paragraph AST nodes. */
export class MarkdownParagraphBuffer extends MarkdownParentBuffer<mdast.Paragraph, mdast.Paragraph> {
  private trailingBreakCount = 0;

  constructor() {
    super({
      type: 'paragraph',
      children: [],
    });
  }

  push(content: mdast.PhrasingContent) {
    super.push(content);

    this.trailingBreakCount = content.type === 'break' ? this.trailingBreakCount + 1 : 0;
  }

  shouldFlushBefore(content: mdast.PhrasingContent) {
    // Start a new paragraph after having encountered two or more line breaks, to effectively convert line
    // breaks to paragraph margins.
    return content.type !== 'break' && this.trailingBreakCount >= 2;
  }

  protected flushChildren(): mdast.PhrasingContent[] | undefined {
    const children = super.flushChildren();
    const { trailingBreakCount } = this;
    this.trailingBreakCount = 0;

    if (!children) {
      return undefined;
    }

    const firstNonBreakIndex = children.findIndex(child => child.type !== 'break');
    const leadingBreakCount = firstNonBreakIndex === -1 ? 0 : firstNonBreakIndex;
    const trimmedChildren = children.slice(
      leadingBreakCount,
      trailingBreakCount > 0 ? -trailingBreakCount : undefined,
    );

    if (trimmedChildren.length === 0) {
      return undefined;
    }

    return trimmedChildren;
  }
}
